import { useState } from "react";
import StaffHeader from "@/components/StaffHeader";
import PerformanceFilters from "@/components/admin/performance/PerformanceFilters";
import PerformanceSummaryCards from "@/components/admin/performance/PerformanceSummaryCards";
import PerformanceChart from "@/components/admin/performance/PerformanceChart";
import PerformanceBreakdownTable from "@/components/admin/performance/PerformanceBreakdownTable";
import PerformanceDonorsList from "@/components/admin/performance/PerformanceDonorsList";
import MetaSyncPanel from "@/components/admin/performance/MetaSyncPanel";

function last30Days() {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 30);
  const fmt = (d) => d.toISOString().slice(0, 10);
  return { start: fmt(start), end: fmt(end), campaign: "" };
}

export default function Performance() {
  const [range, setRange] = useState(last30Days());

  return (
    <div className="min-h-screen bg-amtm-bg">
      <StaffHeader />
      <div className="max-w-6xl mx-auto px-4 py-6 pb-24">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
          <h1 className="font-display text-3xl text-amtm-text" data-testid="performance-page-title">Performance</h1>
          <MetaSyncPanel />
        </div>
        <PerformanceFilters range={range} onChange={setRange} />
        <PerformanceSummaryCards range={range} />
        <PerformanceChart range={range} />
        <PerformanceBreakdownTable range={range} />
        <PerformanceDonorsList range={range} />
      </div>
    </div>
  );
}
